export default __webpack_public_path__ + "static/media/MaskGroup317.7b31f51f.png";